<template>
  <p class="info-message" v-if="isShowMessage">
    <LabelFunMessage fcontId="0" msgkey="38" />
  </p>
</template>

<script>
import { mapState } from "vuex";
import LabelFunMessage from "./LabelFunMessage";

export default {
  name: "InfoMachineTranslation",
  components: {
    LabelFunMessage,
  },
  computed: {
    ...mapState(["lg2"]),
    isShowMessage(){
      return (this.lg2 != "ja") && (this.lg2 != "en")
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-message {
  margin-top: 40px;
}

/* スマホサイズのみ適用 */
@media screen and (max-width: 991px) {
  .info-message {
    margin-top: 20px;
  }
}

/* PCサイズのみ適用 */
@media screen and (min-width: 992px) {
  
}
</style>
